import { LoggedInUserType } from '../helpers/enum';
import { store } from '../../root/store';
import { getIsLoggedInOnBehalf, getUserData } from '../../auth/slice';
import { getWorkspace } from '../../workspace/slice';
import { isEmpty } from 'lodash';

export const useGetLoggedInUserType = (): LoggedInUserType => {
  const userData = getUserData(store.getState());
  const workspaceData = getWorkspace(store.getState());
  const isLoggedInOnBehalf = getIsLoggedInOnBehalf(store.getState());

  if (userData.role === 'admin' && !isLoggedInOnBehalf) {
    console.log('super-admin 986');
    return 'super-admin';
  }
  if (!workspaceData.id && userData.role === 'support' && !isLoggedInOnBehalf) {
    return 'support';
  }
  if (userData.inviteUserType === 'CFA') {
    return 'cfa';
  }
  if (userData.inviteUserType === 'Sales') {
    return 'sales';
  }
  if (isEmpty(workspaceData)) return 'principal';
  // if (workspaceData.isSeller && workspaceData.isBuyer) return 'distributor';
  return workspaceData.isSeller ? 'principal' : 'distributor';
};
